import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getProcessData, getHistoricData, getRequestData, registerFormClient, updateStatusApi, StatusResultIdentityApi,
  checkOtpProcessApi, validateOTP, consultFlagValidateEmail, getVerificationData, identityValidationsApplyApi, getStructureConsult,
  issueCertificate
} from './clientProcessAPI';

const initialState = {
  status: "idle",
  statusHistoric: "idle",
  statusRequest: "idle",
  statusRegister: "idle",
  statusVerificationList:"idle",
  clientProcessData: [],
  clientHistoric: [],
  clientRequest: [],
  clientRegister: [],
  clientRegisterProcess: [],
  verificationList:[],

  statusUpdateStatus: "idle",
  updateStatusData: "",
  messageupdateStatusData: "",

  statusStateResultIdentity: "idle",
  statusResultIdentityData: "",
  messageResultIdentityData: "",

  statusFlagValidateEmail: "idle",
  flagValidateEmail: "",
  statusCheckOTPProcess: "idle",
  checkOTPProcess: "",
  messageErrorCheckOTPProcess: "",

  statusValidateOTP: "idle",
  validateOTP: "",
  messageErrorValidateOTP: "",

  statusIdentityValidationsApply: "idle",
  identityValidationsApplyData: "",
  messageIdentityValidationsApply: "",

  statusStructreConsult: "idle",
  structureConsultData : "",

  statusIssueCertificate: "idle",
  issueCertificateResult : {},
};

export const dataClientProcess = createAsyncThunk(
  '/clientProcess',
  async (data) => {
    const response = await getProcessData(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);
export const dataVerificationProcess = createAsyncThunk(
  '/clientProcess/verificationList',
  async (data) => {
    const response = await getVerificationData(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const datahistoricProcess = createAsyncThunk(
  '/clientProcess/historic',
  async (data) => {
    const response = await getHistoricData(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const dataRequest = createAsyncThunk(
  '/clientProcess/processData',
  async (data) => {
    const response = await getRequestData(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const structureConsult = createAsyncThunk(
  '/clientProcess/structureConsult',
  async (data) => {
    const response = await getStructureConsult(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const registerformProcess = createAsyncThunk(
  '/clientProcess/register',
  async (data) => {
    const response = await registerFormClient(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const updateStatus = createAsyncThunk(
  '/clientProcess/updateStatus',
  async (data) => {
    const response = await updateStatusApi(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const statusResultIdentity = createAsyncThunk(
  '/clientProcess/statusResultIdentity',
  async (data) => {
    const response = await StatusResultIdentityApi(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);


export const getFlagValidateEmail = createAsyncThunk(
  '/clientProcess/consultFlagValidateEmail',
  async (data) => {
    const response = await consultFlagValidateEmail(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const checkOtpProcess = createAsyncThunk(
  '/clientProcess/checkOTPProcess',
  async (data) => {
    const response = await checkOtpProcessApi(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const validateOTPService = createAsyncThunk(
  '/clientProcess/validateOTP',
  async (data) => {
    const response = await validateOTP(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const identityValidationsApply = createAsyncThunk(
  '/identity/identityValidationsApply',
  async (data) => {
    const response = await identityValidationsApplyApi(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const getIssueCertificate = createAsyncThunk(
  '/clientProcess/getIssueCertificate',
  async (data) => {
    const response = await issueCertificate(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const clientProcessSlice = createSlice({
  name: 'clientProcess',
  initialState,
  reducers: {
    reset: () => initialState,
    clearStatusRegister: (state) => {
      state.statusRegister = "idle";
      state.clientRegister = [];
    },
    clearClientRequest: (state) => {
      state.statusRequest = "idle";
      state.clientRequest = [];
    },
    clearValuesValidateOTP: (state) => {
      state.statusCheckOTPProcess = "idle";
      state.checkOTPProcess = "";
      state.messageErrorCheckOTPProcess = "";
      state.statusValidateOTP = "idle";
      state.validateOTP = "";
      state.messageErrorValidateOTP = "";
    },
    clearValidateIdentityForCP: (state) => {
      state.statusUpdateStatus = "idle";
      state.updateStatusData = "";
      state.messageupdateStatusData = "";
      state.statusStateResultIdentity = "idle";
      state.statusResultIdentityData = "";
      state.messageResultIdentityData = "";
    },
    clearissueCertificateResult: (state) => {
      state.issueCertificateResult = {}
    }
  },
  extraReducers: (builder) => {
    builder
     //Reducer dataClientProcess
      .addCase(dataClientProcess.pending, (state) => {
        state.clientProcessData = []
        state.status = 'loading';
      })
      .addCase(dataClientProcess.fulfilled, (state, action) => {
        state.status = 'fulfilled';
        state.clientProcessData = action.payload;
      })
      .addCase(dataClientProcess.rejected, (state) => {
        state.status = 'rejected';
      })
       //Reducer datahistoricProcess
      .addCase(datahistoricProcess.pending, (state) => {
        state.statusHistoric = 'loading';
      })
      .addCase(datahistoricProcess.fulfilled, (state, action) => {
        state.statusHistoric = 'fulfilled';
        state.clientHistoric = action.payload;
      })
      .addCase(datahistoricProcess.rejected, (state) => {
        state.statusHistoric = 'rejected';
      })
       //Reducer dataRequest
      .addCase(dataRequest.pending, (state) => {
        state.statusRequest = 'loading';
      })
      .addCase(dataRequest.fulfilled, (state, action) => {
        state.statusRequest = 'fulfilled';
        state.clientRequest = action.payload;
      })
      .addCase(dataRequest.rejected, (state) => {
        state.statusRequest = 'rejected';
      })
      //Reducer registerformProcess
      .addCase(registerformProcess.pending, (state) => {
        state.statusRegister = 'loading';
      })
      .addCase(registerformProcess.fulfilled, (state, action) => {
        state.statusRegister = 'fulfilled';
        state.clientRegister = action.payload;
      })
      .addCase(registerformProcess.rejected, (state) => {
        state.statusRegister = 'rejected';
      })
      //Reducer updateStatus
      .addCase(updateStatus.pending, (state) => {
        state.statusUpdateStatus = 'loading';
      })
      .addCase(updateStatus.fulfilled, (state, action) => {
        state.statusUpdateStatus = 'fulfilled';
        state.updateStatusData = action.payload;
      })
      .addCase(updateStatus.rejected, (state, action) => {
        state.statusUpdateStatus = 'rejected';
        state.messageupdateStatusData = action.error.message;
      })
      //Reducer statusResultIdentity
      .addCase(statusResultIdentity.pending, (state) => {
        state.statusStateResultIdentity = 'loading';
      })
      .addCase(statusResultIdentity.fulfilled, (state, action) => {
        state.statusStateResultIdentity = 'fulfilled';
        state.statusResultIdentityData = action.payload;
      })
      .addCase(statusResultIdentity.rejected, (state, action) => {
        state.statusStateResultIdentity = 'rejected';
        state.messageResultIdentityData = action.error.message;
      })      
      //Reducer getFlagValidateEmail
      .addCase(getFlagValidateEmail.pending, (state) => {
        state.statusFlagValidateEmail = 'loading';
      })
      .addCase(getFlagValidateEmail.fulfilled, (state, action) => {
        state.statusFlagValidateEmail = 'fulfilled';
        state.flagValidateEmail = action.payload;
      })
      .addCase(getFlagValidateEmail.rejected, (state) => {
        state.statusFlagValidateEmail = 'rejected';
      })      
      //Reducer checkOtpProcess
      .addCase(checkOtpProcess.pending, (state) => {
        state.statusCheckOTPProcess = 'loading';
      })
      .addCase(checkOtpProcess.fulfilled, (state, action) => {
        state.statusCheckOTPProcess = 'fulfilled';
        state.checkOTPProcess = action.payload;
        //Validate en caso que sean por listas  o por quickEmail
        if (action.payload && action.payload.message &&
          (action.payload.message === "existing_whitelisted_mail" || action.payload.message === "email_verified_by_quickemail"
          )) {
          state.statusValidateOTP = 'fulfilled';
          state.validateOTP = action.payload;
        }
      })
      .addCase(checkOtpProcess.rejected, (state, action) => {
        state.statusCheckOTPProcess = 'rejected';
        state.messageErrorCheckOTPProcess = action.error.message;
      })
      //Reducer validateOTPService
      .addCase(validateOTPService.pending, (state) => {
        state.statusValidateOTP = 'loading';
      })
      .addCase(validateOTPService.fulfilled, (state, action) => {
        state.statusValidateOTP = 'fulfilled';
        state.validateOTP = action.payload;
      })
      .addCase(validateOTPService.rejected, (state, action) => {
        state.statusValidateOTP = 'rejected';
        state.messageErrorValidateOTP = action.error.message;
      })
      //Reducer dataVerificationProcess
      .addCase(dataVerificationProcess.pending, (state) => {
        state.statusVerificationList = 'loading';
      })
      .addCase(dataVerificationProcess.fulfilled, (state, action) => {
        state.statusVerificationList = 'fulfilled';
        state.verificationList = action.payload;
      })
      .addCase(dataVerificationProcess.rejected, (state) => {
        state.statusVerificationList= 'rejected';
      })
      //Reducer identityValidationsApply
      .addCase(identityValidationsApply.pending, (state) => {
        state.statusIdentityValidationsApply = 'loading';
      })
      .addCase(identityValidationsApply.fulfilled, (state, action) => {
        state.statusIdentityValidationsApply = 'fulfilled';
        state.identityValidationsApplyData = action.payload;
      })
      .addCase(identityValidationsApply.rejected, (state, action) => {
        state.statusIdentityValidationsApply = 'rejected';
        state.messageIdentityValidationsApply = action.error.message;
      })
      //Reducer issueCertificate
      .addCase(getIssueCertificate.pending, (state) => {
        state.statusIssueCertificate = 'loading';
      })
      .addCase(getIssueCertificate.fulfilled, (state, action) => {
        state.statusIssueCertificate = 'fulfilled';
        state.issueCertificateResult = action.payload;
      })
      .addCase(getIssueCertificate.rejected, (state, action) => {
        state.statusIssueCertificate = 'rejected';
      })
      .addCase(structureConsult.pending, (state) => {
        state.statusStructreConsult = 'loading';
      })
      .addCase(structureConsult.fulfilled, (state, action) => {
        state.statusStructreConsult = 'fulfilled';
        state.structureConsultData = action.payload;
      })
      .addCase(structureConsult.rejected, (state, action) => {
        state.statusStructreConsult = 'rejected';
      })
  },
});

export const { reset, clearStatusRegister, clearClientRequest, clearValuesValidateOTP, clearValidateIdentityForCP, clearissueCertificateResult } = clientProcessSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectStatus = (state) => state.clientProcess.status;
export const selectClientProcessData = (state) => state.clientProcess.clientProcessData;

export const selectStatusHistoric = (state) => state.clientProcess.statusHistoric;
export const selectClientHistoric = (state) => state.clientProcess.clientHistoric;

export const selectStatusRequest = (state) => state.clientProcess.statusRequest;
export const selectClientRequest = (state) => state.clientProcess.clientRequest;

export const selectStatusRegister = (state) => state.clientProcess.statusRegister;
export const selectClientRegister = (state) => state.clientProcess.clientRegister;

export const selectStatusUpdateStatus = (state) => state.clientProcess.statusUpdateStatus;
export const selectUpdateStatusData = (state) => state.clientProcess.updateStatusData;
export const selectMessageupdateStatusData = (state) => state.clientProcess.messageupdateStatusData;

export const selectStatusStateResultIdentity = (state) => state.clientProcess.statusStateResultIdentity;
export const selectStatusResultIdentityData = (state) => state.clientProcess.statusResultIdentityData;
export const selectMessageResultIdentityData = (state) => state.clientProcess.messageResultIdentityData;

export const selectStatusFlagValidateEmail = (state) => state.clientProcess.statusFlagValidateEmail;
export const selectFlagValidateEmail = (state) => state.clientProcess.flagValidateEmail;

export const selectStatusCheckOTPProcess = (state) => state.clientProcess.statusCheckOTPProcess;
export const selectCheckOTPProcess = (state) => state.clientProcess.checkOTPProcess;
export const selectMessageErrorCheckOTPProcess = (state) => state.clientProcess.messageErrorCheckOTPProcess;

export const selectStatusValidateOTP = (state) => state.clientProcess.statusValidateOTP;
export const selectValidateOTP = (state) => state.clientProcess.validateOTP;
export const selectMessageErrorValidateOTP = (state) => state.clientProcess.messageErrorValidateOTP;

export const selectStatusVerificationList = (state) => state.clientProcess.statusVerificationList;
export const selectVerificationList = (state) => state.clientProcess.verificationList;

export const selectStatusStructureConsult = (state) => state.clientProcess.statusStructreConsult;
export const selectStructureConsultData = (state) => state.clientProcess.structureConsultData;

export const selectStatusIssueCertificate = (state) => state.clientProcess.statusIssueCertificate;
export const selectIssueCertificateResult = (state) => state.clientProcess.issueCertificateResult;

export const selectStatusIdentityValidationsApply = (state) => state.clientProcess.statusIdentityValidationsApply;
export const selectIdentityValidationsApplyData = (state) => state.clientProcess.identityValidationsApplyData;
export const selectMessageIdentityValidationsApply = (state) => state.clientProcess.messageIdentityValidationsApply;

export default clientProcessSlice.reducer;